export type TiktokPixelType = {
  track: (
    eventName: string,
    config: {
      content_type: string
      value: number
      currency: string
    },
  ) => void
}

const tiktokPixel = {
  changedPlan: (label: string, value: number, currency: string) => {
    window.ttq.track('ChangedPlan', {
      content_type: label,
      value,
      currency,
    })
  },
}

export default tiktokPixel
